import { useCallback, useMemo } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  saveFilterPreference,
  selectAllFilterPreferences,
} from '@user/store/userPreferences'
import { useSelector } from 'react-redux'
import { setOrderBy } from '@user/store/roles/slice'

export const useSaveFilters = () => {
  const dispatch = useAppDispatch()

  const prefs = useSelector(selectAllFilterPreferences)

  const usersPref = useMemo(
    () => prefs.find((p) => p.type === 'roles'),
    [prefs],
  )

  return useCallback(
    (orderBy: string) => {
      dispatch(
        saveFilterPreference({
          id: usersPref?.id,
          type: 'roles',
          name: 'roles filters',
          filter: JSON.stringify({ orderBy }),
        }),
      )
      dispatch(setOrderBy(orderBy))
    },
    [dispatch, usersPref?.id],
  )
}
